<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.firstname"
            :error-messages="firstnameErrors"
            :label="$t('contact.firstname')"
            required
            @input="$v.item.firstname.$touch()"
            @blur="$v.item.firstname.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.lastname"
            :error-messages="lastnameErrors"
            :label="$t('contact.lastname')"
            required
            @input="$v.item.lastname.$touch()"
            @blur="$v.item.lastname.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="customerSelectItems"
            v-model="item.customer"
            :items="customerSelectItems"
            :error-messages="customerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.customer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('contact.comptehub') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.comptehub"
                :error-messages="comptehubErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.email"
            :error-messages="emailErrors"
            :label="$t('contact.email')"
            @input="$v.item.email.$touch()"
            @blur="$v.item.email.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.phone"
            :error-messages="phoneErrors"
            :label="$t('contact.phone')"
            @input="$v.item.phone.$touch()"
            @blur="$v.item.phone.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="localeSelectItems"
            v-model="item.locale"
            :items="localeSelectItems"
            :error-messages="localeErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('contact.locale')"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';

export default {
  name: 'ContactForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.customerGetSelectItems();


  },
  data() {
    return {
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        locale: null,
        customer: null,
        comptehub: null,
        localeSelectItems:  [
            'en',
            'fr'
          ],
    };
  },
  computed: {
    isLoading() {
      return (
      this.isLoading_customer
       );
    },
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
      isLoading_customer : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    firstnameErrors() {
      const errors = [];

      if (!this.$v.item.firstname.$dirty) return errors;

      has(this.violations, 'firstname') && errors.push(this.violations.firstname);

      !this.$v.item.firstname.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    lastnameErrors() {
      const errors = [];

      if (!this.$v.item.lastname.$dirty) return errors;

      has(this.violations, 'lastname') && errors.push(this.violations.lastname);

      !this.$v.item.lastname.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    emailErrors() {
      const errors = [];

      if (!this.$v.item.email.$dirty) return errors;

      has(this.violations, 'email') && errors.push(this.violations.email);

      !this.$v.item.email.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.item.phone.$dirty) return errors;
      has(this.violations, 'phone') && errors.push(this.violations.phone);
      return errors;
    },
    localeErrors() {
      const errors = [];
      if (!this.$v.item.locale.$dirty) return errors;
      has(this.violations, 'locale') && errors.push(this.violations.locale);
      return errors;
    },
    customerErrors() {
      const errors = [];

      if (!this.$v.item.customer.$dirty) return errors;

      has(this.violations, 'customer') && errors.push(this.violations.customer);


      return errors;
    },
    comptehubErrors() {
      const errors = [];

      if (!this.$v.item.comptehub.$dirty) return errors;

      has(this.violations, 'comptehub') && errors.push(this.violations.comptehub);


      return errors;
    },


    violations() {
      return this.errors || {};
    }
  },
  methods: {

    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems',
    }),
  },
  validations: {
    item: {
      firstname: {
        required,
      },
      lastname: {
        required,
      },
      customer: {

      },
      comptehub: {

      },
      email: {
        required,
      },
      phone: {

      },
      locale: {

      },
    }
  }
};
</script>
